export default __webpack_public_path__ + "static/media/fan_auto.c298136a.svg";